import { render } from "./ReceivedInvitationList.vue?vue&type=template&id=338e708e&scoped=true"
import script from "./ReceivedInvitationList.vue?vue&type=script&lang=js"
export * from "./ReceivedInvitationList.vue?vue&type=script&lang=js"

import "./ReceivedInvitationList.vue?vue&type=style&index=0&id=338e708e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338e708e"]])

export default __exports__